import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import {reduxForm} from 'redux-form';
import Dialog from 'infrastructure/js/components/Dialog/dialog';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import * as dialogHelper from 'infrastructure/js/components/Dialog/dialogHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import {gridsNames} from '../../../enums/gridsNames';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import LabelWithTooltipCell from '../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell';
import {enumTypes, getEnumLabel, getEnumValue} from '../../../utils/enumHelper';
import LabelWithStyleAndTooltipCell from '../../Common/CustomGridCells/LabelWithStyleAndTooltipCell/labelWithStyleAndTooltipCell';

require('./updateKitTypeVersionDialog.scss');

class UpdateKitTypeVersionDialog extends React.PureComponent {

  constructor(props) {
    super(props);

    this.dialogLabels = createLabelHelper('mat.dialog.');
    this.gridLabels = createLabelHelper('mat.grid.');
    this.labels = createLabelHelper('mat.administration.matsettings.dialog.updatekitTypeVersion.');
    this.columnsConfig = this.createColumnsConfig();
  }

  isMultiKitTypes = () => {
    return !!this.props.sData?.get('headerData');
  }

  createColumnsConfig = () => {
    let columnsConfig =  [
      {
        fieldName: 'businessId',
        title: this.gridLabels.get('columns.workOrder.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        },
      },
      ...( this.isMultiKitTypes() ? [{
        fieldName: 'kitTypeBusinessId',
        title: this.gridLabels.get('columns.kitType.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        },
      }] : []),
      {
        fieldName: 'kitTypeRevision',
        title: this.gridLabels.get('columns.kitTypeVersion.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithStyleAndTooltipCell,
          valueGetter: (params) => {
            let revision = params?.data?.kitTypeRevision;
            let latestRevision = params?.data?.kitTypeLatestRevisionNumber;
            let isLatestRevision = revision === latestRevision;
            return {
              label: revision ?? '',
              style: isLatestRevision ? null : { color: '#d9385c' },
              tooltip: isLatestRevision ? null : this.gridLabels.get('cells.tooltip.latestRevision', '', {revision: latestRevision}),
            };
          },
        },
      },
      {
        fieldName: 'tasksStatus',
        title: this.gridLabels.get('columns.status.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return getEnumLabel(enumTypes.WORK_ORDER_TASKS_STATUS)(params?.data?.tasksStatus) ?? '';
          }
        },
      },
    ]
    return columnsConfig;
  }

  getDialogButtons() {
    let selectedRowsData = this.props.sGrid?.get('selectedRowsData') ?? List();

    return {
      left: [
        {
          id:'cancel',
          text: this.dialogLabels.get('cancel'),
          action: this.props.actions.hide,
          disabled: this.props.sData.get('loading')
        }
      ],
      right: [
        {
          id:'submit',
          text: this.dialogLabels.get('update'),
          bsStyle: 'primary',
          loading: this.props.sData.get('loading'),
          action: this.props.handleSubmit(this.onSubmit),
          disabled: (!selectedRowsData?.size ||
                    this.props.sData.get('loading') ||
                    this.props.sData.get('hasError') ||
                    ( this.props.sData.get('showIgnoreValidationCheckbox') &&
                      !this.props.sData.get('isIgnoreValidationWarnings') )
          )
        }
      ]
    };
  }

  createSubmitData = (selectedWOs) => {
    if (this.isMultiKitTypes()) {
      let grouped = selectedWOs?.reduce((acc, item) => { //group by kitTypeId
        const key = item.kitTypeId;
        if (!acc[key]) acc[key] = [];

        acc[key].push(item?.id);
        return acc;
      }, {}) ?? [];

      const workOrdersByKitTypes = Object.keys(grouped)?.map(key => {
          return {
            kitTypeId: +key,
            workOrderIds: grouped[key]
          }
        }
      ) ?? [];
      return {workOrdersByKitTypes};
    }
    return {
      workOrderIds: selectedWOs.map(item => item.id),
      kitTypeId: this.props.sData?.get('kitTypeId')
    }
  }

  onSubmit = () => {
    let selectedWOs = this.props.sGrid?.get('selectedRowsData')?.toJS() ?? [];

    const data = this.createSubmitData(selectedWOs);

    this.props.actions.submit(data, this.getMessageDialogBuilder(), null, {isMultiKitTypes: this.isMultiKitTypes()} );
  };

  getMessageDialogBuilder = () => {
    return (response, fnCloseDialog) => {
      // Multi-kit-types: the batch job's numberOfSucceededItems/totalJobItems count kit-type GROUPS
      // (chunk(1), one item per group), not individual work orders - using them here undercounts
      // (e.g. "46 out of 46" instead of "990 out of 990"). The grid holds one row per work order
      // regardless of path, so use its selection/rows counts for both paths instead.
      let count = this.props.sGrid?.get('selectedRowsData')?.size ?? 0;
      let allItemsNum = this.props.sGrid?.get('rows')?.size ?? 0;
      let title = this.labels.get('confirmation.success', '', {count, allItemsNum});
      let className = 'oneBackground';
      return {title, className};
    }
  }

  onHide =() => {
    this.props.actions.hide();
  };

  getFooterValidationCheckBox = () => {
    return this.props.sData.get('showIgnoreValidationCheckbox') ?
      {label: this.dialogLabels.get('ignorewarnings'),onChange: this.onFooterValidationChange} : null;
  };

  onFooterValidationChange = (value) => {
    this.props.actions.toggleIgnoreValidationWarningsCheckbox(value);
  };

  getValidationWarning = (count, labelKey) => {
    return count ? (
      <div><span className='pl pl-warning-icon'></span><span>{this.labels.get(labelKey, '', {count}) }</span></div>
    ) : null;
  }

  renderHeader = () => {
    if (!this.isMultiKitTypes()) {
      return <label>{this.labels.get('top.title')}</label>;
    }

    const headerData = this.props.sData?.get('headerData');
    const {numberOfSucceededItems: successItems, numberOfFailedItems: errorItems, numberOfItemsWithWarnings: warningItems} = headerData;

    let errorIcon = 'pl pl-canceled-icon';
    let warningIcon = 'pl pl-warning-icon';
    let successIcon  = 'pl pl-check-circle-icon-blue blue-color';

    return (
      <div className='header-area'>
        <div className='import-info-items'>
          {successItems > 0 ?
            <div className='import-info-item'>
              <span className={`import-info-icon ${successIcon}`}/>
              <label
                className='import-info-msg'>{`${successItems} ${this.labels.get('top.status.succeeded', '', {count: successItems})}`}</label>
            </div> : null}
          {warningItems > 0 ?
            <div className='import-info-item'>
              <span className={`import-info-icon ${warningIcon} warning`}/>
              <label
                className='import-info-msg'>{`${warningItems} ${this.labels.get('top.status.failed', '', {count: warningItems})}`}</label>
            </div> : null}
          {errorItems > 0 ?
            <div className='import-info-item'>
              <span className={`import-info-icon ${errorIcon}`}/>
              <label
                className='import-info-msg'>{`${errorItems} ${this.labels.get('top.status.warning', '', {count: errorIcon})}`}</label>
            </div> : null}
        </div>
        <label>{this.labels.get('top.title.import')}</label>
      </div>
    );
  }

  renderWarningsArea = () => {
    let selectedRowsData = this.props.sGrid?.get('selectedRowsData')?.toJS() ?? [];

    const {scheduled, started} = selectedRowsData.reduce(
      (acc, item) => {
        if (item.tasksStatus === getEnumValue(enumTypes.WORK_ORDER_TASKS_STATUS)('SCHEDULED')) {
          acc.scheduled++;
        } else if (item.tasksStatus === getEnumValue(enumTypes.WORK_ORDER_TASKS_STATUS)('STARTED')) {
          acc.started++;
        }
        return acc;
      }, {scheduled: 0, started: 0}
    );

    return (
      <div className="warnings-area">
        {this.getValidationWarning(scheduled, 'warning.scheduled')}
        {this.getValidationWarning(started, 'warning.started')}
      </div>
    );
  }

  getTitle = () => {
    if (!this.isMultiKitTypes()) {
      return this.labels.get('header.title');
    }
    return this.labels.get('header.title.import' , '', {count: this.props.sData?.get('headerData')?.totalJobItems ?? 0})
  }

  render() {
    return (
      <Dialog
        id="update-kit-type-version-dialog"
        className="update-kit-type-version-dialog"
        titleText={ this.getTitle()}
        show={this.props.sData.get('show')}
        onEntered={this.onEntered}
        onHide={this.onHide}
        sData={this.props.sData}
        footerValidationCheckbox={this.getFooterValidationCheckBox()}
        footerInformationIcon={dialogHelper.getFooterInformationIcon(this.props.sData, this.dialogLabels)}
        footerButtons={this.getDialogButtons()}
        onEnterKeyPress={this.props.handleSubmit(this.onSubmit)}
      >

        {this.props.sData.get('loading') && <Overlay.Loading />}

        {this.renderHeader()}


        <Grid gridName={gridsNames.ADMINISTRATION_MAT_SETTINGS_UPDATE_KIT_TYPE_VERSION}
              className='select-work-orders-grid'
              columnsConfig={this.columnsConfig}
              rows={this.props.sData.get('items') ?? []}
              isStatic={true}
              gridProps={
                {
                  getRowHeight: this.getRowHeight,
                  sideBar: false,
                }
              }
        >
        </Grid>
        {this.renderWarningsArea()}
      </Dialog>
    );
  }
}

export default reduxForm({
    form: 'updateKitTypeVersionDialog',
    onChange: (values, dispatch, props, previousValues) => {
      dialogHelper.onFormChangeHandler(values, props, previousValues);
    },
  }
)(UpdateKitTypeVersionDialog);

UpdateKitTypeVersionDialog.propTypes = {
  actions: PropTypes.object.isRequired,
  sData: PropTypes.object.isRequired,
};


